import { MenuItem, MenuSeparator, Text, Box } from '@chakra-ui/react';
import { MdDelete as DeleteIcon, MdDriveFileRenameOutline as RenameIcon } from 'react-icons/md';

interface CollectionActionsMenuProps {
  onRename?: () => void;
  onDelete?: () => void;
  deleteLoading?: boolean;
}

const itemStyles = {
  px: 3,
  py: '10px',
  gap: 3,
  borderRadius: 'md',
  _hover: { bg: 'bg.muted', cursor: 'pointer' },
} as const;

export default function CollectionActionsMenu({
  onRename,
  onDelete,
  deleteLoading,
}: CollectionActionsMenuProps) {
  return (
    <>
      {onRename && (
        <MenuItem value="rename" onClick={onRename} {...itemStyles}>
          <Box color="accent.secondary"><RenameIcon size={16} /></Box>
          <Text fontFamily="body" fontWeight="500" fontSize="sm" color="text.primary">Rename</Text>
        </MenuItem>
      )}
      {onDelete && (
        <>
          <MenuSeparator borderColor="border.muted" mx={2} my={1} />
          <MenuItem
            value="delete"
            onClick={onDelete}
            {...itemStyles}
            _hover={{ bg: '#fff5f3', cursor: 'pointer' }}
            disabled={deleteLoading}
          >
            <Box color="status.error"><DeleteIcon size={16} /></Box>
            <Text fontFamily="body" fontWeight="500" fontSize="sm" color="status.error">Delete Collection</Text>
          </MenuItem>
        </>
      )}
    </>
  );
}
